require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/fn/object/assign.js
// module id = 233
// module chunks = 0